import { Injectable } from '@angular/core';
import { HttpUrlBuilderService } from '../http/http-url-builder.service';
import { RegionStorageService } from '../region/region-storage.service';

@Injectable({
  providedIn: 'root'
})
export class WebApiUrlBuilderService {

  constructor(private httpUrlBuilder: HttpUrlBuilderService,
     private regionStorageService: RegionStorageService) {}


  createUrl(protocol, domain, port, path) {
    return this.httpUrlBuilder.createUrl(protocol, domain, port, path);
  }

  createImplicitPortUrl(protocol, domain, path) {
    return this.httpUrlBuilder.createImplicitPortUrl(protocol, domain, path);
  }

  createResourceUrl(configuration, resourcePath) {
    return this.createWebApiUrl(configuration) + resourcePath;
  }

  buildDomainString(configuration) {
    const region = this.loadRegion();
    if (typeof configuration === "string") {
      return configuration;
    } else {
      return configuration.regionPrefix + "." + region + "." + configuration.regionSuffix;
    }
  }

  createWebApiUrl(configuration) {
    const domainString = this.buildDomainString(configuration.domain);
    if (configuration.port) {
      return this.createUrl(configuration.protocol, domainString, configuration.port, configuration.path);
    } else {
      return this.createImplicitPortUrl(configuration.protocol, domainString, configuration.path);
    }
  }

  loadRegion() {
    return this.regionStorageService.loadRegion();
  }
}
